export const _title = 'Digital Solutions'
export const _description = 'Achieve high value results with a strategic vision that aligns the latest digital technologies to your business goals.'
export const _image = 'https://s3.us-east-2.amazonaws.com/cdn.www.oos-studio.com/prod/oosMountains_PreviewImage.jpg'
export const _keywords = 'React.JS, React, Node.JS, Node, Custom, Development, Software, Web, Website, Business, Consulting, IoT, Digital, Transformation, Technology, Change, Cloud, Strategy, Design, i4.0, Process'

export const parseKeywords = (keywords) => {
  let keywordString = ''
  keywords.forEach((key, index) => {
    if (index < keywords.length - 1) {
      keywordString += `${key.keywordTitle},`
    } else {
      keywordString += key.keywordTitle
    }
  })
  return keywordString
}

export const getMeta = (title = _title, description = _description, image = _image, keywords = _keywords) => {
  return {
    title,
    description,
    meta: {
      charset: 'utf-8',
      name: {
        keywords: keywords,
      },
      itemProp: {
        title,
        description,
        image,
      },
      property: {
        'og:title': title,
        'og:type': 'website',
        'og:image': image,
        'og:site_name': 'oos',
        'og:description': description,
        'og:url': window.location.href,
        'fb:app_id': '2317018421941218',
      }
    },
    auto: {
      ograph: true
    }
  }
}
